import { render, staticRenderFns } from "./addOwnerRepair.vue?vue&type=template&id=120c669f"
import script from "./addOwnerRepair.vue?vue&type=script&lang=js"
export * from "./addOwnerRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports